import {
    useAPIQuery,
    useGlobalAPIQueryContext,
} from "@dev2_techwalnut/tw-api-query-hook";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import secureLocalStorage from "react-secure-storage";
import Swal from "sweetalert2";

const DeliveryStatusModal = ({ row, tolerance }) => {
    const userID = secureLocalStorage.getItem("userID");
    const {
        register,
        handleSubmit,
        formState: { errors, isValid },
    } = useForm({
        mode: "onBlur",
    });

    const { invalidateApi } = useGlobalAPIQueryContext();

    const { useUpdate: useUpdatePurchaseOrder } = useAPIQuery({
        key: "purchase-order",
        endpoint: "/api/purchase-order/",
    });

    const { mutate: updatePO } = useUpdatePurchaseOrder({
        successMessageFromServer: true,
        errorMessageFromServer: true,
        onSuccess: () => {
            invalidateApi({ key: "api/generic" });
        },
    });

    const onSubmit = (data) => {
        console.log(data);
        Swal.fire({
            title: "Do you want mark this purchase order as completed?",
            showDenyButton: true,
            showCancelButton: true,
            confirmButtonText: "Yes",
            denyButtonText: `No`,
        }).then((result) => {
            if (result.isConfirmed) {
                updatePO({
                    id: row?.id,
                    data: {
                        received_quantity: Number(data?.allotQuantity),
                        invoice_no: data?.invoice,
                        batch_number: data?.batch_no,
                        is_complete: true,
                        updated_by: userID,
                    },
                });
            } else if (result.isDenied) {
                updatePO({
                    id: row?.id,
                    data: {
                        received_quantity: Number(data?.allotQuantity),
                        invoice_no: data?.invoice,
                        batch_number: data?.batch_no,
                        updated_by: userID,
                    },
                });
            }
        });
    };

    useEffect(() => {
        return () => {
            const backdrop = document.querySelector(".modal-backdrop");
            if (backdrop) {
                backdrop.remove();
                document.body.classList.remove("modal-open");
                document.body.style = "";
            }
        };
    }, []);

    return (
        <div>
            <div
                className="modal fade m-0 p-0"
                tabIndex={-1}
                id={`delivery-status-modal-${row?.id}`}
                aria-modal
            >
                <div className="modal-dialog modal-sm" role="document">
                    <div className="modal-content">
                        <button
                            type="button"
                            className="close"
                            data-bs-dismiss="modal"
                        >
                            <em
                                className="icon ni ni-cross"
                                aria-hidden="true"
                            ></em>
                        </button>
                        <div className="modal-header">
                            <h5 className="modal-title">Allot Quantity</h5>
                        </div>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label htmlFor="wo">
                                                Allot Quantity
                                            </label>
                                            <div>
                                                <span className="fs-8 text-success">
                                                    Previously allotted
                                                    quantity:
                                                    {row?.received_quantity}
                                                </span>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    defaultValue={0}
                                                    id="number-forms-payment_terms"
                                                    step="any"
                                                    {...register(
                                                        `allotQuantity`,
                                                        {
                                                            required:
                                                                "Cannot be empty",
                                                            validate: {
                                                                positive: (
                                                                    value
                                                                ) =>
                                                                    !value ||
                                                                    value >=
                                                                        0 ||
                                                                    "Only positive numbers are allowed",
                                                                limit: (
                                                                    value
                                                                ) =>
                                                                    Number(
                                                                        value
                                                                    ) +
                                                                        Number(
                                                                            row?.received_quantity
                                                                        ) <=
                                                                        row?.quantity +
                                                                            (Number(
                                                                                row?.quantity
                                                                            ) /
                                                                                100) *
                                                                                (tolerance ??
                                                                                    5) ||
                                                                    `Cannot allot more than requested quantity i.e ${
                                                                        row?.quantity +
                                                                        (Number(
                                                                            row?.quantity
                                                                        ) /
                                                                            100) *
                                                                            (tolerance ??
                                                                                5)
                                                                    } (+${
                                                                        tolerance ??
                                                                        5
                                                                    }% threshold included)`,
                                                            },
                                                        }
                                                    )}
                                                    readOnly={row?.is_complete}
                                                />
                                                {errors.allotQuantity && (
                                                    <span className="fs-8 text-danger">
                                                        {
                                                            errors.allotQuantity
                                                                .message
                                                        }
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12 mt-3">
                                        <div className="form-group">
                                            <label htmlFor="wo">Invoice</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                defaultValue={
                                                    row?.invoice?.invoice_no ??
                                                    ""
                                                }
                                                id="text-forms-invoice"
                                                {...register("invoice", {
                                                    maxLength: {
                                                        value: 15,
                                                        message:
                                                            "Maximum length is 15 characters",
                                                    },
                                                })}
                                            />
                                            {errors.invoice && (
                                                <span className="fs-8 text-danger">
                                                    {errors.invoice.message}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-md-12 mt-3">
                                        <div className="form-group">
                                            <label htmlFor="wo">Batch No</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                defaultValue={row?.batch ?? ""}
                                                id="text-forms-invoice"
                                                {...register(`batch_no`, {
                                                    maxLength: {
                                                        value: 15,
                                                        message:
                                                            "Maximum length is 15 characters",
                                                    },
                                                })}
                                            />
                                            {errors.batch_no && (
                                                <span className="fs-8 text-danger">
                                                    {errors.batch_no.message}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer bg-light">
                                <button
                                    type="submit"
                                    className="btn btn-primary"
                                    data-bs-dismiss="modal"
                                    disabled={!isValid}
                                >
                                    Submit
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <button
                type="button"
                className="btn btn-primary btn-sm ms-1"
                data-bs-toggle="modal"
                data-bs-target={`#delivery-status-modal-${row?.id}`}
                disabled={row?.activity_status === 3}
            >
                Receive Quantity
            </button>
        </div>
    );
};

export default DeliveryStatusModal;
